export const environment = {
  production: false,
  protocol: 'https://',
  // applicationUrl: 'glacial-bastion-78267.herokuapp.com',
  applicationUrl: 'gift-shop-api-pgkj.onrender.com', //renderUrl
  authService: '',
  productService: '',
  orderService: '',
  paymentService: '',
  cartService: '',
  mapQuestAPIKey: 'nXLMbpX6U0545mAaAJyeI2QQd1JYVqG4',
  mapQuestUrl: 'https://www.mapquestapi.com/directions/v2/route',
  publicStripeKey:
    'pk_test_51I3zWOI8py6Rj5ufY6RnJ1zjPK930I2xwWW0XKPWFr6cp7mAvgM8q8aoAV5R0trqmGEEqSgrLY6xVhZRqTsgZJqE00zW2TqkZa',
  publicRazorpayKey: 'rzp_test_QHK5P7ne66SdWo',
  googleClientId:
    '120787335948-g4r6bof29ub3vaaaiu7pc01jd5dalooq.apps.googleusercontent.com',
  facebookClientId: '745534413011559',
  from: '400072',
};
